import script from "./LookButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./LookButton.vue?vue&type=script&lang=ts&setup=true"

import "./LookButton.vue?vue&type=style&index=0&id=7d092338&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d092338"]])

export default __exports__